import {BehaviorsResource} from 'common/report/model-resources/behaviors';
import {contextify} from 'common/util/react';

const context = contextify<BehaviorsResource>();

export const BehaviorsProvider = context.Provider;
export const BehaviorsConsumer = context.Consumer;
export const useBehaviors = context.hook;
